/* eslint-disable */

import * as d3 from 'd3'
import { createAxis, escapeHtml, extractTypesCategories, getScale, joinArrayId, setScalesAxis } from './utilities'
import { CrainD3Vis } from './CrainD3Vis.js'
import store from '@/store/store'

class ScatterPlotControl extends CrainD3Vis {
    constructor(svg, cd, svgDiv) {
        super(svg, cd, svgDiv);
        this.selectClass = 'datacircle';
        this.scatterSelectedCategories = new Set();
        this.scatterSelectedTypes = new Set();
        this.xAxis = undefined;
        this.yAxis = undefined;
        this.xScale = undefined;
        this.yScale = undefined;
        this.typeColors = undefined;
        this.showTypeCatLabels = false; // Adds additional (interactive) screen element with types and categories
        this.showLabelVisibility = false; // Adds additional (interactive) screen element with labels
        this.controlNormalFormatting = this.controlNormalFormatting.bind(this);
        this.controlSelectFormatting = this.controlSelectFormatting.bind(this);
        this.layout = {
            graphWidth: document.getElementById(this.svgDiv.split(" ")[0].slice(1)).offsetWidth,
            graphHeight: document.getElementById(this.svgDiv.split(" ")[0].slice(1)).offsetHeight,
            fullWidth: document.getElementById(this.svgDiv.split(" ")[0].slice(1)).offsetWidth,
            fullHeight: document.getElementById(this.svgDiv.split(" ")[0].slice(1)).offsetHeight,
            noMarginGraphWidth: undefined,
            noMarginGraphHeight: undefined,
            colWidth: undefined,
            margin: undefined,
            radius: undefined,
            selectRadius: undefined,
            responsive: document.getElementById(this.svgDiv.split(" ")[0].slice(1)).getAttribute("layout"),
            transform: 1
        };

        this.config = {
            radius: 8,
            selectRadius: 10,
            extendedGraphWidth: 1600,
            extendedGraphHeight: 800,
            normalGraphWidth: 800,
            normalGraphHeight: 800,
            margin: 50,
            colWidth: 200,
            categoryLowerLimit: 3,
            radiusRatio: 28.294, // => 800 / 28.294 = 3^2 * Pi
            selectRadiusRatio: 10.1859, // => 800 / 10.1859 = 5^2 * Pi
        }
    }

    layoutCalculations() {
        this.responsive = this.layout.responsive;
        if (this.layout.graphWidth && this.layout.graphHeight && this.responsive) {
            //this.layout.fullHeight = parseInt(this.svg.attr('height'));
            //this.layout.graphHeight = this.layout.fullHeight;
            //this.layout.fullWidth = parseInt(this.svg.attr('width'));
            //this.layout.graphWidth = this.showTypeCatLabels ? 0.5 * this.layout.fullWidth : this.layout.fullWidth;
            //this.layout.graphWidth = this.showTypeCatLabels ? 0.5 * document.getElementById('svgDiv').offsetWidth : document.getElementById('svgDiv').offsetWidth;
            //this.layout.graphHeight = document.getElementById('svgDiv').offsetHeight;
            this.layout.colWidth = this.layout.graphWidth / 8;
            this.layout.margin = 0.0625 * this.layout.graphWidth;
            //this.layout.radius = (Math.min(this.layout.graphWidth, this.layout.graphHeight) / (this.config.radiusRatio * Math.PI)) ** 0.5;
            //this.layout.selectRadius = (Math.min(this.layout.graphWidth, this.layout.graphHeight) / (this.config.radiusRatio * Math.PI)) ** 0.5;
            this.layout.radius = this.config.radius;
            this.layout.selectRadius = this.config.selectRadius;
            this.svg.attr('width', this.layout.fullWidth);
            this.svg.attr('height', this.layout.fullHeight);
        } else {
            this.layout.margin = this.config.margin;
            this.layout.colWidth = this.config.colWidth;
            this.layout.fullWidth = this.showTypeCatLabels ? this.config.extendedGraphWidth : this.config.normalGraphWidth;
            this.layout.fullHeight = this.showTypeCatLabels ? this.config.extendedGraphHeight : this.config.normalGraphHeight;
            this.layout.graphHeight = this.config.normalGraphHeight;
            this.layout.graphWidth = this.config.normalGraphWidth;
            this.layout.radius = this.config.radius;
            this.layout.selectRadius = this.config.selectRadius;

            this.svg.attr('width', this.layout.fullWidth);
            this.svg.attr('height', this.layout.fullHeight);
        }
        this.layout.noMarginGraphWidth = this.layout.graphWidth - 2 * this.layout.margin;
        this.layout.noMarginGraphHeight = this.layout.graphHeight - 2 * this.layout.margin;
    }

    initializeZoom() {
        const zoom = d3.zoom()
            .scaleExtent([0.5, 20]) // Define the zoom scale limits
            .translateExtent([[-100, -100], [this.layout.graphWidth + 100, this.layout.graphHeight + 100]]) // Define the translation limits
            .on('zoom', this.zoomed.bind(this));
    
        this.svg.call(zoom);
    }
    
    zoomed() {
        const outer = this.svg.select('g#main');
        const g = this.svg.select('g#main g#graph');
        
        const transform = d3.event.transform;
        this.layout.transform = transform;
        if (transform && g) {
            //console.log(transform.k);
            g.attr('transform', transform);
            g.selectAll('circle')
                .attr('r', d => this.layout.radius/transform.k);
            
            //const xA = createAxis(this, outer, true)
            //const yA = createAxis(this, outer, true)
            //console.log("X:", xA[0].scale);
            //console.log("Y:", yA[0].scale);
            //console.log("Transform:", d3.event ? d3.event.transform : null);
            outer.select('#gXAxis').call(transform.rescaleX(this.xScale.scale));
            outer.select('#gYAxis').call(transform.rescaleY(this.yScale.scale));
        } else {
            console.error("Transform or elements are not defined properly.");
        }
    }

    createScales(processedData, onX, onY) {
        // Create Scales
        this.xScale = getScale(onX, processedData);
        this.xScale.scale = this.xScale.scale.range([0, this.layout.graphWidth - 2 * this.layout.margin]).clamp(true);
        this.yScale = getScale(onY, processedData);
        this.yScale.scale = this.yScale.scale.range([this.layout.graphHeight - 2 * this.layout.margin, 0]);
    }

    showTypesCategories(g) {
        /**
         * g = group to append svg elements to
         **/

        let { types, categories, categoriesConv } = extractTypesCategories(this.crainData.xLayers, this.crainData.processedData);
        types = Object.entries(types).sort((a, b) => b[1] - a[1]).slice(0, 10);
        this.typeColors = {};
        types.forEach((d, c) => this.typeColors[d[0]] = d3.schemeTableau10[c]);

        this.crainData.processedData.map(x => x.color = this.typeColors[x.type]);
        // Reset selected categories and types
        this.scatterSelectedCategories = new Set();
        this.scatterSelectedTypes = new Set();

        if (this.showTypeCatLabels) {
            let graphSpace = g.select('g#graph');
            let obj = this;

            let gTypes = g.select('g#gTypes');
            let gCategories = g.select('g#gCategories');

            let gTypesGroup;
            if (gTypes.empty()) {
                gTypes = g.append('g').attr('id', 'gTypes')
                gTypes.append('g')
                    .attr('id', 'typesTitle')
                    .attr('transform', 'translate(' + this.layout.colWidth / 2 + ',' + 30 + ')')
                    .append('text')
                    .attr('text-anchor', 'center')
                    .attr('font-weight', 'bold')
                    .attr('fill', '#444')
                    .text('TYPES');
                gTypesGroup = gTypes.append('g')
                    .attr('id', 'typesGroup')
                    .attr('transform', 'translate(0,' + 80 + ')');
            } else {
                gTypesGroup = g.select('#typesGroup')
            }
            if (gCategories.empty()) {
                gCategories = g.append('g').attr('id', 'gCategories');
                gCategories.append('g')
                    .attr('id', 'categoriesTitle')
                    .attr('transform', 'translate(' + this.layout.colWidth / 2 + ',' + 30 + ')')
                    .append('text')
                    .attr('text-anchor', 'center')
                    .attr('font-weight', 'bold')
                    .attr('fill', '#444')
                    .text('CATEGORIES');

                var gCategoriesGroup = gCategories.append('g')
                    .attr('id', 'categoriesGroup')
                    .attr('transform', 'translate(0,' + 80 + ')');
            } else {
                var gCategoriesGroup = g.select('#categoriesGroup');
            }

            gTypes.attr('transform', 'translate(' + this.layout.graphWidth + ',0)');
            gCategories.attr('transform', 'translate(' + (this.layout.graphWidth + this.layout.colWidth) + ',0)');

            categories = Object.entries(categories).filter(x => x[1] >= this.config.categoryLowerLimit).sort((a, b) => b[1] - a[1]);

            let gTypesLabels = gTypesGroup.selectAll('g.gTypeLabels').data(types.slice(0, 10), d => d[0]);
            let gCategoriesLabels = gCategoriesGroup.selectAll('g.gCategoriesLabels')
                .data(categories.slice(0, 20), d => d[0]);
            let newGTypesLabels = gTypesLabels.enter().append('g').attr('class', 'gTypeLabels');
            let newGCategoriesLabels = gCategoriesLabels.enter().append('g').attr('class', 'gCategoriesLabels');
            gTypesGroup.exit().remove();
            gCategoriesGroup.exit().remove();
            gTypesLabels.exit().remove();
            gCategoriesLabels.exit().remove();


            newGTypesLabels.append('text').attr('font-size', 12).attr('alignment-baseline', 'central');
            newGTypesLabels.append('rect').attr('font-size', 12).attr('width', 10).attr('height', 10)
                .attr('fill', (d) => this.typeColors[d[0]]).attr('transform', 'translate(0,' + (-12 / 2) + ')');
            newGTypesLabels.merge(gTypesLabels)
                .attr('transform', (d, c) => 'translate(' + this.layout.margin + ',' + c * 12 + ')')
                .select('text')
                .attr('transform', 'translate(12,0)')
                .text(d => d[0] + " (" + d[1] + ")")
                .attr('font-weight', 'normal')
                .on('click', function(d) {
                    if (obj.scatterSelectedTypes.has(d[0])) {
                        d3.select(this).attr('font-weight', 'normal');
                        obj.scatterSelectedTypes.delete(d[0]);
                    } else {
                        d3.select(this).attr('font-weight', 'bold');
                        obj.scatterSelectedTypes.add(d[0]);
                    }
                    d3.selectAll('g.' + obj.selectClass).call(obj.controlDataPointFormatting);
                });

            newGTypesLabels.merge(gTypesLabels)
                .select('rect');

            newGCategoriesLabels.append('text').attr('font-size', 12)
                .on('mouseover', function(d) {
                    g.selectAll('g.' + d[0] + '').select('circle').attr('r', obj.layout.selectRadius).attr('fill-opacity', 1)
                        .attr('fill', d => d.color);
                    graphSpace.selectAll('g:not(.' + d[0] + ')').select('circle').attr('fill-opacity', 0)
                })
                .on('mouseout', function() {
                    graphSpace.selectAll('g.' + obj.selectClass).call(obj.controlDataPointFormatting)
                })
                .on('click', function(d) {
                    if (obj.scatterSelectedCategories.has(d[0])) {
                        obj.scatterSelectedCategories.delete(d[0]);
                        d3.select(this).attr('font-weight', 'normal');
                    } else {
                        obj.scatterSelectedCategories.add(d[0]);
                        d3.select(this).attr('font-weight', 'bold');
                    }
                    graphSpace.selectAll('g.' + obj.selectClass).call(obj.controlDataPointFormatting);
                });

            newGCategoriesLabels.merge(gCategoriesLabels)
                .attr('transform', (d, c) => 'translate(' + this.layout.margin + ',' + c * 12 + ')')
                .select('text')
                .attr('font-weight', 'normal')
                .text(d => categoriesConv[d[0]] + " (" + d[1] + ")");
        }

    }

    update(reset, resetTypeCat = false, onX = "size_log", onY = "recency_linear") {
        //console.log(onX, onY);
        let cd = this.crainData;
        this.selectModus = true;
        let svgDiv = this.svgDiv;

        this.layoutCalculations();

        let g;
        if (reset) {
            this.svg.select('g#main').remove();
            g = this.svg.append('g').attr('id', 'main')
                .attr('transform', 'translate(' + this.layout.margin + ',' + this.layout.margin + ')')
                .attr('height', this.layout.graphHeight)
        } else {
            g = this.svg.select('g#main')
        }

        let graphSpace = g.select('g#graph');
        if (graphSpace.empty()) {
            graphSpace = g.append('g').attr('id', 'graph')
            graphSpace.append('rect').attr('height', this.layout.noMarginGraphHeight).attr('width', this.layout.noMarginGraphWidth)
                .attr('opacity', 0)
        }

        // Initialize and apply zoom
        //this.initializeZoom();

        // DATA PREP
        // General
        this.createScales(cd.processedData, onX, onY);
        if (resetTypeCat || this.typeColors === undefined) {
            this.showTypesCategories(g);
        }



        let axX = createAxis(this, g, true);
        let gXAxis = axX[0];
        this.xAxis = axX[0];
        let gXAxisLabel = axX[1];

        let axY = createAxis(this, g, false);
        let gYAxis = axY[0];
        this.yAxis = axY[0];
        let gYAxisLabel = axY[1];
        gXAxis.attr('transform', 'translate(0,' + this.layout.noMarginGraphHeight + ')');
        gXAxisLabel.attr('transform', 'translate(' + this.layout.noMarginGraphWidth / 2 + ',' +
                    (this.layout.noMarginGraphHeight + (0.75 * this.layout.margin)) + ')');

        //gYAxis.attr('transform', 'translate('+ this.layout.noMarginGraphWidth / 2 + ', 0 )');            
        gYAxisLabel.attr('transform', 'translate(' + (-0.75 * this.layout.margin) + ',' +
                    this.layout.noMarginGraphHeight / 2 + ')');

        // Set scales
        setScalesAxis(this, g);
        cd.processedData.forEach(d => {
           d.xPos = this.xScale.scale(d[this.xScale.location][this.xScale.field])
           d.yPos = this.yScale.scale(d[this.yScale.location][this.yScale.field])
        });

        graphSpace
            .on('mousemove', (d, c, node) => {
                let pos = d3.mouse(node[0])
                let x = pos[0];
                let xDiff = event.clientX - x;
                let y = pos[1];
                let yDiff = event.clientY - y;
                let minDist;
                let points = [];
                cd.processedData.forEach(d =>  {
                    let dist = ((x - d.xPos)**2 + (y - d.yPos)**2)**0.5;
                    if ((minDist === undefined) || (minDist > dist)) {
                        minDist = dist;
                        points = [d]
                    } else if (minDist === dist) {
                        points.push(d)
                    }
                });
                graphSpace.select('#accentCircle').remove();
                if (points.length > 1) {
                    d3.select('#hoverDiv')
                        .style('opacity', 0.9)
                        .style('top', points[0].yPos + yDiff + 10 + 'px')
                        .style('left', points[0].xPos + xDiff + 10 + 'px')
                        // .style('z-index', 9999)
                        .html(`
                            <strong>
                                ${points
                                    .slice(0,10)
                                    .map(point => cd.xLayers.find(l => l[0]._id === point.id[0][0])
                                    .map(el => el ? escapeHtml(el.name) : "All")
                                    .join(' - '))
                                    .join('<br>')
                                }
                            </strong><br>
                            ${points.length > 10 ? "..." : ""}
                        `)

                } else if (points.length === 1) {
                    d3.select('#hoverDiv')
                        .style('opacity', 0.9)
                        .style('top', points[0].yPos + yDiff + 10 + 'px')
                        .style('left', points[0].xPos + xDiff + 10 + 'px')
                        // .style('z-index', 9999)
                        .html(`
                            <strong>
                                ${cd.xLayers.find(l => l[0]._id === points[0].id[0][0])
                                    .map(el => el ? escapeHtml(el.name) : "All")
                                    .join('<br>')}
                            </strong><br>
                            <br>
                            Size: ${points[0].filtdata? points[0].filtdata.size:points[0].data.origsize}<br>
                            Recency: ${points[0].filtdata? points[0].filtdata.recency:points[0].data.recency}<br>
                            Origsize: ${points[0].data.origsize} (${cd.rawData.meta.poolstart}-${cd.rawData.meta.poolstop})
                        `)
                }
                graphSpace.append('circle').attr('id', 'accentCircle').attr('fill-opacity', 0)
                    .style('pointer-events', 'none')
                    .attr('stroke', 'black').attr('stroke-width', 1)
                    .attr('transform', 'translate(' + points[0].xPos + "," + points[0].yPos + ")");
            })
            .on('mouseleave', (d,c,node) => {
                // Only move out of selected can remove hoverdiv
                d3.select('#hoverDiv')
                    .style('opacity', 0)
                graphSpace.select('#accentCircle').remove();
            })
        ;


        // Create (data)circles
        let gCircles = graphSpace.selectAll('g.' + this.selectClass).data(cd.processedData, d => d.id);
        gCircles.exit().remove()

        let obj = this;
        let newGCircles = gCircles.enter().append('g')
            .attr('class', d => {
                return obj.selectClass + " " + d.type + " " + d.categories.join(' ');
            })

        console.log("labels", this.showLabelVisibility);
        newGCircles.append('circle')
            .attr('r', 8)
            .attr('fill', (d, c) => this.typeColors[joinArrayId(cd.xLayers[c])])
            .attr('stroke', (d, c) => this.typeColors[joinArrayId(cd.xLayers[c])])
            .attr('stroke-opacity', 1)
            .attr('stroke-width', 0.2)

        if(this.showLabelVisibility){
            newGCircles.append('text')
                .attr('fill', (d, c) => this.typeColors[joinArrayId(cd.xLayers[c])])
                .attr('font-size', 8)
                .attr('stroke', (d, c) => this.typeColors[joinArrayId(cd.xLayers[c])])
                .attr('stroke-width', 0.2)
                .text(d => { return d.fingerprint[3]});
        }

        newGCircles.merge(gCircles)
            .attr('transform', d => 'translate(' + d.xPos + ',' + d.yPos + ')')
            .call(this.controlDataPointFormatting);

        this.controlSelect();


        //setTimeout(() => {
        //    store.dispatch('loadAnimEnd');
        store.dispatch('saveLoadingStep', "");
        //}, 5000);
    }

    controlNormalFormatting(selection) {
        let typecats = [];
        selection.each((d) => {

            if (this.scatterSelectedTypes.size > 0 || this.scatterSelectedCategories.size > 0) {
                d.selectedTypeCat = false;
                let type = false;
                let categories = false;

                if (this.scatterSelectedTypes.has(d.type)) {
                    type = true;
                    d.selectedTypeCat = true;
                }
                if (d.categories.some(cat => this.scatterSelectedCategories.has(cat))) {
                    d.selectedTypeCat = true;
                    categories = true;
                }
                typecats.push({ type: type, categories: categories })
            } else {
                d.selectedTypeCat = true;
                typecats.push({ type: true, categories: false })
            }
        });
        selection.select('circle').attr('fill-opacity', (d, c) => typecats[c].type || typecats[c].categories ? 1 : 0.1)
            .attr('fill', (d, c) => typecats[c].type || typecats[c].categories ? d.color : 'lightgray')
            .attr('stroke', (d, c) => typecats[c].type || typecats[c].categories ? d.color : 'lightgray')
            .attr('r', (d, c) => typecats[c].categories ? this.layout.selectRadius : this.layout.radius);
        selection.sort((a, b) => a.selectedTypeCat - b.selectedTypeCat)
    }

    controlSelectFormatting(selection) {
        if (this.crainData.selected.size > 0) {
            selection.select('circle')
                .attr('stroke', d => d.selected ? d.color : '#777')
                .attr('fill', d => d.selected ? d.color : '#777')
                .attr('fill-opacity', d => d.selected ? 1 : 0.1)
        } else {
            selection.select('circle')
                .attr('r', this.layout.radius)
                .attr('stroke', d => d.color)
                .attr('fill', d => d.color)
                .attr('fill-opacity', 0.1);
        }
    }
}




export { ScatterPlotControl }